<div class="mt-3">
	<div class="row">
		<div class="col-7">
			<div class="row">
				<div class="col-7 gap-2">
					<app-reservation-summary-owner></app-reservation-summary-owner>
					<app-reservation-summary-invoice></app-reservation-summary-invoice>
				</div>
				<div class="col-5">
					<app-reservation-summary-agent></app-reservation-summary-agent>
				</div>
			</div>
			<div class="row mt-3">
				<app-reservation-summary-alerts></app-reservation-summary-alerts>
			</div>
			<div class="row mt-3">
				<div class="col-12">
					<app-reservation-summary-accomodation></app-reservation-summary-accomodation>
				</div>
			</div>
		</div>
		<div class="col-5 d-flex flex-column gap-2">
			<app-reservation-summary-status></app-reservation-summary-status>
			<app-reservation-summary-guide></app-reservation-summary-guide>
			<mat-expansion-panel
				(opened)="notesPanelOpenState = true"
				(closed)="notesPanelOpenState = false"
				[expanded]="notesPanelOpenState"
			>
				<mat-expansion-panel-header>
					<mat-panel-title>Notatki</mat-panel-title>
				</mat-expansion-panel-header>
				<app-note-list
					[view]="'summary'"
					[showHidden]="false"
					[tableName]="TableName.RESERVATION"
					[tableId]="reservationID()"
				></app-note-list>
			</mat-expansion-panel>
			<mat-expansion-panel (opened)="tasksPanelOpenState = true" (closed)="tasksPanelOpenState = false">
				<mat-expansion-panel-header>
					<mat-panel-title>Zadania</mat-panel-title>
				</mat-expansion-panel-header>
				<app-tasks-list
					[tableId]="reservationID()"
					[tableName]="TableName.RESERVATION"
					[view]="'summary'"
				></app-tasks-list>
			</mat-expansion-panel>
			<app-reservation-summary-payments (resizeState)="resizePayments($event)"></app-reservation-summary-payments>
			<app-reservation-summary-documents></app-reservation-summary-documents>
			<app-reservation-summary-payments-summary> </app-reservation-summary-payments-summary>
		</div>
	</div>
</div>
